<div class="border bg-white rounded mt-3 p-4 div-shadow">
  <!--FOTO PRINCIPAL-->
  <div class="row mb-3">
    <div class="col-4 col-sm-4 col-md-3 col-lg-2">
      <img [src]="app.previewUrl ? app.previewUrl : mascota.foto?.foto_thumb" class="rounded pointer" width="100%" alt="Foto mascota"
          (click)="app.onClickImagenMascotaPrincipal()">
    </div>
    <div class="col">
      <div class="row">
        <div class="col">
          <label for="ma_nombre" class="form-label">Nombre</label>
          <input type="text" id="ma_nombre" class="form-control" [(ngModel)]="mascota.ma_nombre">
        </div>
      </div>
      <div class="d-none d-lg-block">
        <div class="row">
          <div class="col-auto">
            <label for="ma_sexo" class="form-label">Sexo</label>
            <select id="ma_sexo" class="form-select" [(ngModel)]="mascota.ma_sexo">
              <option value=""></option>
              <option value="Macho">Macho</option>
              <option value="Hembra">Hembra</option>
              <option value="Desconocido">Desconocido</option>
              <option value="No aplica">No aplica</option>
            </select>
          </div>
          <div class="col-auto">
            <label for="ma_fecha_nac" class="form-label">Fecha de nacimiento</label>
            <input type="date" id="ma_fecha_nac" class="form-control" [(ngModel)]="mascota.ma_fecha_nac">
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <label for="mt_tipo" class="form-label">Tipo</label>
            <ng-select #selectTiposMascota
                      class="form-select w-100" 
                      [items]="app.tipos_mascotas" 
                      bindLabel="mt_tipo" 
                      bindValue="mt_tipo"
                      groupBy="mt_categoria" 
                      name="mt_tipo"
                      maxlength="100"
                      notFoundText="Tipo no encontrado"
                      [placeholder]="mascota.ma_tipo ? '' : 'Escribe para buscar...'"
                      [(ngModel)]="mascota.ma_tipo">
              <ng-template ng-optgroup-tmp let-item="item">
                {{ item.mt_categoria || 'Otros' }}
              </ng-template>
            </ng-select>
          </div>
          <div class="col-6">
            <label for="ma_raza" class="form-label">Raza</label>
            <input type="text" id="ma_raza" class="form-control" [(ngModel)]="mascota.ma_raza">
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <label for="ma_tamano" class="form-label">Tamaño</label>
            <select id="ma_tamano" class="form-select" [(ngModel)]="mascota.ma_tamano">
              <option value=""></option>
              <option value="Pequeño">Pequeño</option>
              <option value="Mediano">Mediano</option>
              <option value="Grande">Grande</option>
            </select>
          </div>
          <!--<div class="col-6">
            <label for="ma_peso" class="form-label">Peso <span class="small">(Kg)</span></label>
            <input type="number" id="ma_peso" class="form-control" [(ngModel)]="mascota.ma_peso">
          </div>-->
          <div class="col-6">
            <label>Nivel de energía</label>
            <select id="ma_energia" class="form-select" [(ngModel)]="mascota.ma_energia">
              <option value=""></option>
              <option value="1">Bajo (tranquilo, mayor, poco activo)</option>
              <option value="2">Medio (activo pero equilibrado)</option>
              <option value="3">Alto (muy activo, necesita ejercicio frecuente)</option>
              <option value="4">Muy alto (extremadamente activo, necesita ejercicio constante)</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="d-xs-block d-lg-none mb-3">
    <div class="row">
      <div class="col-6">
        <label for="ma_sexo" class="form-label">Sexo</label>
        <select id="ma_sexo" class="form-select" [(ngModel)]="mascota.ma_sexo">
          <option value=""></option>
          <option value="Macho">Macho</option>
          <option value="Hembra">Hembra</option>
          <option value="Desconocido">Desconocido</option>
          <option value="No aplica">No aplica</option>
        </select>
      </div>
      <div class="col-6">
        <label for="ma_fecha_nac" class="form-label">Fecha nacimiento</label>
        <input type="date" id="ma_fecha_nac" class="form-control" [(ngModel)]="mascota.ma_fecha_nac">
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <label for="mt_tipo" class="form-label">Tipo</label>
        <ng-select #selectTiposMascota
                  class="form-select w-100" 
                  [items]="app.tipos_mascotas" 
                  bindLabel="mt_tipo" 
                  bindValue="mt_tipo"
                  groupBy="mt_categoria" 
                  name="mt_tipo"
                  maxlength="100"
                  notFoundText="Tipo no encontrado"
                  [placeholder]="mascota.ma_tipo ? '' : 'Escribe para buscar...'"
                  [(ngModel)]="mascota.ma_tipo">
          <ng-template ng-optgroup-tmp let-item="item">
            {{ item.mt_categoria || 'Otros' }}
          </ng-template>
        </ng-select>
      </div>
      <div class="col-6">
        <label for="ma_raza" class="form-label">Raza</label>
        <input type="text" id="ma_raza" class="form-control" [(ngModel)]="mascota.ma_raza">
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <label for="ma_tamano" class="form-label">Tamaño</label>
        <select id="ma_tamano" class="form-select" [(ngModel)]="mascota.ma_tamano">
          <option value=""></option>
          <option value="Pequeño">Pequeño</option>
          <option value="Mediano">Mediano</option>
          <option value="Grande">Grande</option>
        </select>
      </div>
      <!--<div class="col-6">
        <label for="ma_peso" class="form-label">Peso <span class="small">(Kg)</span></label>
        <input type="number" id="ma_peso" class="form-control" [(ngModel)]="mascota.ma_peso">
      </div>-->
      <div class="col-6">
        <label>Nivel de energía</label>
        <select id="ma_energia" class="form-select" [(ngModel)]="mascota.ma_energia">
          <option value=""></option>
          <option value="1">Bajo (tranquilo, mayor, poco activo)</option>
          <option value="2">Medio (activo pero equilibrado)</option>
          <option value="3">Alto (muy activo, necesita ejercicio frecuente)</option>
          <option value="4">Muy alto (extremadamente activo, necesita ejercicio constante)</option>
        </select>
      </div>
    </div>
  </div>

  <!--PERSONALIDAD-->
  <strong>Personalidad de tu mascota, selecciona los rasgos que mejor la representan</strong>
  <div class="mb-3 p-2 border rounded-4">
    <!--<label class="form-label">Personalidad de tu mascota, selecciona los rasgos que mejor la representan</label>-->
    <div class="row">
      <div class="row">
        <div class="col-auto mb-2" *ngFor="let personalidad of personalidades">
          <div class="form-check">
            <input 
              class="form-check-input"
              type="checkbox"
              [checked]="app.personalidadesSeleccionadas.includes(personalidad)"
              (change)="onCheckChange($event, personalidad)"
              [id]="'check' + personalidad.va_id">

            <label class="form-check-label" [for]="'check' + personalidad.va_id">
              {{ personalidad.va_nombre }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <strong>Presenta a tu mascota, qué la hace especial... ¡y todas sus locuras!</strong>
  <div class="mb-3">
    <!--<label for="ma_descripcion" class="form-label">Presenta a tu mascota, qué la hace especial... ¡y todas sus locuras!</label>-->
    <textarea autoResize [maxLines]="5" [maxChars]="500" id="ma_descripcion" class="form-control" rows="3" [(ngModel)]="mascota.ma_descripcion"></textarea>
  </div>

  <!--FOTOS-->
  <app-mascota-fotos [mascota]="mascota"></app-mascota-fotos>

  <!--ATRIBUTOS-->
  <!--
  <div *ngIf="mascota.ma_id != 0">
    <label for="at_atributo" class="mini form-label">Describe en palabras sueltas tus habilidades, formas de ser, características… Estas palabras ayudarán a encontrar perfiles similares que encajen con tu estilo e intereses</label>
    <div class="row">
      <div class="col-auto" *ngFor="let atributo of mascota.atributos">
        <span class="badge bg-primary-light text-dark cerrar-contenedor mini">
          {{atributo.at_atributo}}
          <span class="cerrar" (click)="app.quitaAtributo(atributo.at_atributo)"><i class="text-dark fa-solid fa-xmark"></i></span>
        </span>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col mb-2">
        <input type="text" class="form-control" [(ngModel)]="app.atributo" id="at_atributo" maxlength="20" soloLetras (keyup.enter)="app.nuevoAtributo()">
      </div>
      <div class="col-auto">
        <button class="btn btn-sm btn-primary mb-2" (click)="app.nuevoAtributo()">Añadir</button>
      </div>
    </div>
  </div>
  <div *ngIf="app.error != ''" class="alert alert-danger alert-dismissible fade show" role="alert">
    {{this.app.error}}
    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
  </div>
  -->

  <!--<app-info-privada [mascota]="mascota" [edit]="true"></app-info-privada>-->

  <div class="w-100 align-items-end">
    <div class="row mt-3 justify-content-end">
      <div class="col">
        <!--Visibilidad-->
        <div class="visibility-control" [ngClass]="{' is-private': mascota.ma_novisible == 'X'}" data-visible-label="Visible en comunidad" data-hidden-label="No visible en comunidad">
          <span class="visibility-status" *ngIf="mascota.ma_novisible == ''">Mascota pública, es visible para toda la comunidad</span>
          <span class="visibility-status" *ngIf="mascota.ma_novisible == 'X'">Mascota no pública, solo el visible para ti</span>
          <label class="switch-control">
            <input class="visibility-toggle" type="checkbox"
            role="switch" 
            id="switchNoVisible"
            [checked]="mascota.ma_novisible == ''"
            (change)="mascota.ma_novisible = $event.target.checked ? '' : 'X'">
            <span></span>
            <strong>Mostrar</strong>
          </label>
        </div>
      </div>
      <div class="col-auto text-end mb-3">
        <button class="btn btn-sm btn-secondary" title="Guardar cambios" (click)="app.borrarMascota()" *ngIf="mascota.ma_id != 0">Borrar</button>
      </div>
      <div class="col-auto text-end mb-3">
        <button class="btn btn-sm btn-secondary" title="Cancelar cambios" (click)="app.cancelarEdicion()">Cancelar</button>
      </div>
      <div class="col-auto text-end mb-3">
        <button class="btn btn-sm btn-primary" title="Guardar cambios" (click)="app.guardarMascota()">Guardar</button>
      </div>
    </div>
  </div>
</div>
